var render = function render(_c,_vm){return _c('span',{staticClass:"py-3"},[_vm._v(_vm._s(_vm._f("dateIfToday")(_vm.props.item[_vm.props.value])))])
}
var staticRenderFns = []

export { render, staticRenderFns }